// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import { MemberListFragmentFragmentDoc } from "../../MemberList/gql/Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteOrganizationMemberMutationMutationVariables = Types.Exact<{
  membershipId: Types.Scalars["ID"]["input"];
}>;

export type DeleteOrganizationMemberMutationMutation = {
  __typename?: "Mutation";
  deleteOrganizationMember: {
    __typename?: "DeleteOrganizationMemberPayload";
    organization: {
      __typename?: "Organization";
      id: string;
      permittedToInviteMembers: boolean;
      samlIntegration?: {
        __typename?: "SamlIntegration";
        id: string;
        idpEntityId: string;
      } | null;
      memberships: Array<{
        __typename?: "OrganizationMembership";
        id: string;
        createdAt: number;
        email: string;
        samlUid?: string | null;
        accepted: boolean;
        expired: boolean;
        user?: {
          __typename?: "User";
          id: string;
          avatarUrl?: string | null;
          fullname?: string | null;
        } | null;
        permissions?: Array<{
          __typename?: "OrganizationPermission";
          id: string;
          restricted: boolean;
          view: boolean;
          modify: boolean;
          billing: boolean;
          api: boolean;
          manage: boolean;
          createWorkbooks: boolean;
        } | null> | null;
      }>;
    };
  };
};

export const DeleteOrganizationMemberMutationDocument = gql`
  mutation DeleteOrganizationMemberMutation($membershipId: ID!) {
    deleteOrganizationMember(membershipId: $membershipId) {
      organization {
        ...MemberListFragment
      }
    }
  }
  ${MemberListFragmentFragmentDoc}
`;
export type DeleteOrganizationMemberMutationMutationFn =
  Apollo.MutationFunction<
    DeleteOrganizationMemberMutationMutation,
    DeleteOrganizationMemberMutationMutationVariables
  >;

/**
 * __useDeleteOrganizationMemberMutationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMemberMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMemberMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMemberMutationMutation, { data, loading, error }] = useDeleteOrganizationMemberMutationMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useDeleteOrganizationMemberMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOrganizationMemberMutationMutation,
    DeleteOrganizationMemberMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteOrganizationMemberMutationMutation,
    DeleteOrganizationMemberMutationMutationVariables
  >(DeleteOrganizationMemberMutationDocument, options);
}
export type DeleteOrganizationMemberMutationMutationHookResult = ReturnType<
  typeof useDeleteOrganizationMemberMutationMutation
>;
export type DeleteOrganizationMemberMutationMutationResult =
  Apollo.MutationResult<DeleteOrganizationMemberMutationMutation>;
export type DeleteOrganizationMemberMutationMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteOrganizationMemberMutationMutation,
    DeleteOrganizationMemberMutationMutationVariables
  >;
